import { DateTime } from 'luxon';

import { DayNum } from '../../../types';
import { StoreFieldsFragment } from '../../graphql';
import { StoreHours } from '../../types';
import { parseStoreDayHours } from '../parseStoreDayHours';
import { validateStoreHoursString } from '../validateStoreHoursString';

export const getStoreHours = (
	store: StoreFieldsFragment,
	now: DateTime
): StoreHours => {
	const output: StoreHours = {
		1: undefined,
		2: undefined,
		3: undefined,
		4: undefined,
		5: undefined,
		6: undefined,
		7: undefined
	};

	const {
		sunOpen,
		sunClose,
		monThruThursOpen,
		monThruThursClose,
		friOpen,
		friClose,
		satOpen,
		satClose
	} = store;

	if (
		validateStoreHoursString(sunOpen) &&
		validateStoreHoursString(sunClose)
	) {
		output[7] = parseStoreDayHours(
			sunOpen,
			sunClose,
			store.timeZone,
			7,
			now
		);
	}

	if (
		validateStoreHoursString(monThruThursOpen) &&
		validateStoreHoursString(monThruThursClose)
	) {
		for (let i = 1; i < 5; ++i) {
			output[i as DayNum] = parseStoreDayHours(
				monThruThursOpen,
				monThruThursClose,
				store.timeZone,
				i as DayNum,
				now
			);
		}
	}

	if (
		validateStoreHoursString(friOpen) &&
		validateStoreHoursString(friClose)
	) {
		output[5] = parseStoreDayHours(
			friOpen,
			friClose,
			store.timeZone,
			5,
			now
		);
	}

	if (
		validateStoreHoursString(satOpen) &&
		validateStoreHoursString(satClose)
	) {
		output[6] = parseStoreDayHours(
			satOpen,
			satClose,
			store.timeZone,
			6,
			now
		);
	}

	return output;
};
